import { projectFunctions } from '@/firebase/config';

/**
 * ตรวจสอบว่า document ยังเป็น schema เก่าหรือไม่
 * ค่า default ใช้กับ bag/storage ที่ควรมี currentWeight/maxLoad
 * แต่บาง collection เช่น mysteriousStorages ไม่มี field พวกนี้ตามปกติ
 */
export function isOldSchema(docData, options = {}) {
  const { requireWeightFields = true } = options;

  if (!docData) return false;

  // schema เก่ามักเก็บ inventory เป็น array
  if (Array.isArray(docData.inventory)) return true;

  // ถ้ายังไม่มี items เลย ให้ถือว่ายังไม่ migrate
  if (docData.items === undefined || docData.items === null) return true;

  // bag/storage ที่ไม่มีทั้ง currentWeight และ maxLoad มักเป็น schema ค้างช่วง migrate
  if (
    requireWeightFields &&
    typeof docData.items === 'object' &&
    docData.currentWeight === undefined &&
    docData.maxLoad === undefined
  ) {
    return true;
  }

  return false;
}

/**
 * เรียก gameActions เพื่อ set migratedToItemV2 = false
 * ทำให้ App.vue แสดง MigrateItemModal อัตโนมัติ
 */
export async function triggerReMigration() {
  try {
    const gameActions = projectFunctions.httpsCallable('gameActions');
    await gameActions({ action: 'characterActions', subAction: 'setMigratedToItemV2', value: false });
  } catch (err) {
    console.error('[MigrationGuard] Failed to trigger re-migration:', err);
  }
}
